import React, { Component } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Table, Icon } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';

import {RenderEditProjectCost} from './UiUtils'


class ViewInHouseCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            customers: [],
            inhouseCosts: [],
            totalCost: 0,
            modalOpen: false,
        }
    }

    componentDidMount() {
        console.log("inhpc3 ++++++++++ ViewInHouseCosts componentDidMount");
        console.log("inhpc311 this.props.user.email:"+this.props.user.email);
        this.getInHouseCosts()
    }


    getInHouseCosts = () => {
        console.log("inhpc31 ++++++++:getInHouseCosts");
        console.log("inhpc32 this.props.user.email:"+this.props.user.email);

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getInHouseCosts', {
            apiKey: "asdfasdf",
            projectId: this.props.projectId,
            enteredBy: this.props.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("inhpc34:"+JSON.stringify(response.data,null,3));

                if (response.data.result) {
                    console.log("inhpc35: inhouse costs:" + JSON.stringify(response.data.inhouseCosts, null, 3))
                    this.setState({
                        inhouseCosts: response.data.inhouseCosts
                    })
                    //GET TOTAL COSTS
                    //this.getProjectTotalCost(response.data.projectCosts)
                } else {
                    console.log("inhpc36 FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    render() {

        const rows = this.state.inhouseCosts.length > 0
            ? this.state.inhouseCosts.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.idlargeprojectinhousecosts} </Table.Cell>
                    <Table.Cell> {item.itemtypedone.shirttype} </Table.Cell>
                    <Table.Cell> {item.qty} </Table.Cell>
                    <Table.Cell> {toCurrency(item.amount)} </Table.Cell>
                    <Table.Cell> {toCurrency(item.qty * item.amount)} </Table.Cell>
                    <Table.Cell> <Link to={'/dashboard/editInHouseProjectCost/'+item.idlargeprojectinhousecosts}>EDIT</Link> </Table.Cell>
                </Table.Row>)
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>IN HOUSE  COSTS</h2>
                {/* <h3> TOTAL COST:{toCurrency(this.state.totalCost)}</h3> */}
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                        <Table.HeaderCell>Item Id</Table.HeaderCell>
                            <Table.HeaderCell>Item</Table.HeaderCell>
                            <Table.HeaderCell>qty</Table.HeaderCell>
                            <Table.HeaderCell>cost</Table.HeaderCell>
                            <Table.HeaderCell>Total Cost</Table.HeaderCell>
                            <Table.HeaderCell>Edit</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>

            </div>
        );
    }
}

export default ViewInHouseCosts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewInHouseCosts.js